import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { css } from "styled-components";
// D:\johnstoncompanies\johnston\src\FrontEnd\modules\content-library\src\Widgets\

pageContainerStyles.hiddenShippingInfoAndProductListWide = {
    below: "lg",
    css: css`
        width: 100%;
        >div[class^="griditemstyle"]: last-child {
            > div[class^="Wrapper"] {
                > div > div[class^="GridWrapper"] {
                    border-bottom: none;
                    background-color: #ffffff;
                    border: 1px solid #efefef;
                    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
                    padding: 15px;
                    border-radius: 7px;
                    margin-bottom: 10px;
                }
            }
        }
    `,
};

pageContainerStyles.hiddenShippingInfoAndProductListNarrow = {
    above: "md",
    css: css`
            width:100%;
            >div[class^="GridItemStyle"]: last-child {
                >div[class^="Wrapper"]{
                    >div > div[class^="GridWrapper"]{
                        border-bottom: none;
                        background-color: #FFFFFF;
                        border: 1px solid #efefef;
                        box-shadow: 0 3px 5px 0 rgba(0,0,0,.1);
                        padding: 15px;
                        border-radius: 7px;
                        margin-bottom: 10px;
                    }
                    >div >div{
                        border-bottom: none !important;
                    }
                }
            }
        }
    `,
};
